import React from "react";
import { runSelfTests } from "@/lib/claimUtils";
import { ShieldCheck, CheckCircle, XCircle, Warning } from "@phosphor-icons/react";

export default function PrivacyView() {
  const tests = runSelfTests();
  const passed = tests.filter((t) => t.pass).length;

  return (
    <div className="view-grid" data-testid="privacy-view">
      {/* Disclaimer */}
      <div className="panel disclaimer-panel" data-testid="disclaimer-panel">
        <div className="panel-header">
          <Warning size={18} weight="bold" />
          <span>IMPORTANT DISCLAIMER</span>
        </div>
        <div className="panel-body">
          <div className="disclaimer-text" data-testid="disclaimer-text">
            <p><strong>NO LIABILITY.</strong> The creator(s) of this application accept no liability whatsoever for any outcomes, decisions, errors, or consequences resulting from the use of this tool. You use this application entirely at your own risk.</p>
            <p><strong>NOT OFFICIAL VA FORMS.</strong> All documents, worksheets, and PDFs generated by this application are <strong>unofficial planning tools only</strong>. They are NOT official VA forms and must NOT be submitted to the VA as-is. After using this tool to organize your information, you must complete and submit the correct official VA forms available at <a href="https://www.va.gov/find-forms/" target="_blank" rel="noopener noreferrer">VA.gov/find-forms</a>.</p>
            <p><strong>NOT LEGAL, MEDICAL, OR PROFESSIONAL ADVICE.</strong> This application does not provide legal advice, medical advice, or any form of professional counsel. It is not affiliated with the Department of Veterans Affairs, any Veterans Service Organization (VSO), accredited claims agent, attorney, or medical professional. No attorney-client, doctor-patient, or representative-claimant relationship is created by using this tool.</p>
            <p><strong>VERIFY EVERYTHING.</strong> All rating criteria, diagnostic codes, compensation rates, form versions, deadlines, and regulatory references must be independently verified against official sources (VA.gov, eCFR.gov) before taking any action. Information may be outdated, incomplete, or inaccurate.</p>
            <p><strong>THIS TOOL IS FOR PLANNING AND ORGANIZATION ONLY.</strong> It was created to assist veterans in gathering and organizing their claim information in one place. It does not file claims, communicate with the VA, or make any representations on your behalf.</p>
          </div>
        </div>
      </div>

      {/* Privacy */}
      <div className="panel" data-testid="privacy-panel">
        <div className="panel-header">
          <ShieldCheck size={18} weight="bold" />
          <span>PRIVACY & DATA</span>
        </div>
        <div className="panel-body">
          <div className="privacy-text" data-testid="privacy-text">
            <p>Your data is saved to a database and locally on your device. No data is shared with third parties. PDF generation happens entirely in your browser.</p>
            <p><strong>Data currency:</strong> 2026 VA compensation rates (effective Dec 1, 2025, 2.81% COLA). VA Form 21-526EZ (Jan 2026). VA Form 21-0781 (Mar 2024; 21-0781a discontinued Jun 2024). 38 CFR Part 4 via eCFR. All references verified against official VA.gov and eCFR sources.</p>
          </div>
        </div>
      </div>

      {/* Self-tests */}
      <div className="panel" data-testid="tests-panel">
        <div className="panel-header">
          <CheckCircle size={18} weight="bold" />
          <span>SELF-TESTS</span>
          <span className="header-count mono">{passed}/{tests.length}</span>
        </div>
        <div className="panel-body">
          <div className="tests-grid" data-testid="tests-grid">
            {tests.map((test) => (
              <div key={`test-${test.name}`} className={`test-item ${test.pass ? "test-item--pass" : "test-item--fail"}`} data-testid={`test-${test.name.replace(/\s/g, '-')}`}>
                {test.pass ? <CheckCircle size={16} weight="fill" /> : <XCircle size={16} weight="fill" />}
                <span>{test.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
